module.exports = __webpack_public_path__ + "img/fault.bf17d923.png";